import React, { useEffect, useState, useContext, useCallback } from "react";
import { getproductvalue } from "../../../Utility/Api";
import { toast } from "react-toastify";
import { AddRemark } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import { NaviGate } from "../../../Utility/function";
import { Pagination } from "../../Common/Functions";

const Findsale = () => {
  const [Order, setOrder] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [ModalView, setModalView] = useState(false);
  const [un_id, setun_id] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const rolesPerPage = 10;

  const { showLoader, hideLoader, selectedWarehouse } = useContext(WarehouseContext);
  const [formData, setFormData] = useState({
    remark: "",
    sales_id: "",
    product_id: "",
  });


  useEffect(() => {
    if (selectedWarehouse) {
      fetchproduct();
    }
  }, [selectedWarehouse]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };



  const fetchproduct = useCallback(async (page = currentPage, search = searchQuery) => {
    showLoader();
    try {
      const response = await getproductvalue(selectedWarehouse?.id, page, search);
      const { data } = response;

      if (data?.status === "success") {
        setOrder(data.data);
        setTotalPages(data.pagination?.total_pages || 1);
      } else {
        toast.error(data?.message || "Error fetching product data");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error fetching product data");
    } finally {
      hideLoader();
    }
  }, []);

  const handleSubmit = async () => {
    const data = await AddRemark(formData, un_id);
    setModalView(false);
    toast.success("remark Updated successFully");
  };

  // const filteredOrders = Order.filter((order) =>
  //   (order.product_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //    order.product_code?.toLowerCase().includes(searchQuery.toLowerCase()))
  // );


  useEffect(() => {
    fetchproduct(1, searchQuery)
    setCurrentPage(1);

  }, [searchQuery])


  useEffect(() => {
    fetchproduct(currentPage)
  }, [currentPage])



  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };




  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <h6 className="text-uppercase">Find sales price</h6>
        <hr />

        <div className="card">
          <div className="card-body">
            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
              <div className="d-flex position-relative" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <img
                  src="/assets/images/icons/search.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: "18px",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>
            <div
              className="table-responsive text-center my-1 w-100 position-relative"
              style={{ overflowX: "hidden", minHeight: "70vh" }}
            >
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Product Name</th>
                    <th>Batch Code</th>
                    {/* <th>descriptions</th> */}
                    <th>Mfg Price</th>
                    <th>Mfg Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {Order.length > 0 ? (
                    Order.map((order, index) => (
                      <tr key={order.id}>
                        <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                        <td>{order.product_title || "N/A"}</td>
                        <td>{order.batch_no || "N/A"}</td>
                        {/* <td>{order.descriptions || "N/A"}</td> */}
                        {/* <td>
                          {order.avg_sales_price
                            ? order.mfg_price_unit.toFixed(3)
                            : "N/A"}
                        </td> */}
                        <td>{order.mfg_price_unit || "N/A"}</td>
                        <td>{order.mfg_qty || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No products found</td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />

            </div>


          </div>
        </div>

        {ModalView && (
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                    {"Add Remark"}
                  </h5>
                  <button
                    onClick={() => setModalView(false)}
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body" style={{ fontFamily: "poppins" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3 d-flex align-items-center">
                      <label className="col-4 text-normal">Remark</label>
                      <textarea
                        type="text"
                        name="remark"
                        className="form-control"
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                    <div className="form-group mb-3 d-flex align-items-center">
                      <label className="col-4 text-normal">
                        Made of Payment
                      </label>
                      <select className="form-control">
                        <option value="" key="">
                          Online
                        </option>
                        <option value="" key="">
                          offline
                        </option>
                      </select>
                    </div>

                    <div className="mt-5">
                      <button
                        type="submit"
                        className="btn btn-success float-end text-normal rounded-1"
                        style={{ fontFamily: "poppins" }}
                      >
                        Submit
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                        onClick={() => setModalView(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Findsale;
